import PriorityFeedController from './priority_feed/priority_feed';

angular.module('capability-ng-priority-feed').controller('PriorityFeedController', PriorityFeedController);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/views/views_module.ts